<template>
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 10">
      <g id="Group 5">
        <path
          id="Vector 3"
          d="M1 1L5.23531 2.76283V15.4232L1 17.6668V1Z"
          stroke="white"
        />
        <path
          id="Vector 4"
          d="M21 1L16.7647 2.76283V15.4232L21 17.6668V1Z"
          stroke="white"
        />
        <rect
          id="Rectangle 233"
          x="5.5"
          y="2.5"
          width="11"
          height="13"
          stroke="white"
        />
      </g>
      <g
        id="group 1"
        clip-path="url(#clip0)"
      >
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M16.8348 14.0073H15.6747C15.793 14.3311 15.8576 14.6804 15.8576 15.0446V19.4289C15.8576 19.5807 15.8312 19.7264 15.7831 19.8619H17.7009C18.4173 19.8619 19.0001 19.2791 19.0001 18.5627V16.1726C19.0001 14.9787 18.0288 14.0073 16.8348 14.0073Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M7.14262 15.0446C7.14262 14.6804 7.20722 14.3311 7.32546 14.0073H6.16541C4.97144 14.0073 4.00006 14.9787 4.00006 16.1727V18.5628C4.00006 19.2791 4.58287 19.862 5.29927 19.862H7.21712C7.16904 19.7264 7.14262 19.5807 7.14262 19.4289V15.0446Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_3"
              d="M12.8261 12.8794H10.1741C8.98013 12.8794 8.00876 13.8508 8.00876 15.0447V19.4291C8.00876 19.6682 8.20265 19.8621 8.44183 19.8621H14.5584C14.7976 19.8621 14.9915 19.6682 14.9915 19.4291V15.0447C14.9915 13.8508 14.0201 12.8794 12.8261 12.8794Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <path
              id="Vector_4"
              d="M11.5001 7.13745C10.0642 7.13745 8.89603 8.30564 8.89603 9.74158C8.89603 10.7156 9.4336 11.5662 10.2275 12.0128C10.604 12.2246 11.0382 12.3457 11.5001 12.3457C11.9621 12.3457 12.3962 12.2246 12.7728 12.0128C13.5667 11.5662 14.1042 10.7155 14.1042 9.74158C14.1042 8.30567 12.936 7.13745 11.5001 7.13745Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_9">
          <g id="Group_10">
            <path
              id="Vector_5"
              d="M6.92738 9.56494C5.8535 9.56494 4.97986 10.4386 4.97986 11.5125C4.97986 12.5864 5.8535 13.46 6.92738 13.46C7.19979 13.46 7.45918 13.4036 7.69482 13.3021C8.10223 13.1267 8.43815 12.8162 8.64601 12.4273C8.79191 12.1544 8.87491 11.843 8.87491 11.5125C8.87491 10.4386 8.00127 9.56494 6.92738 9.56494Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_11">
          <g id="Group_12">
            <path
              id="Vector_6"
              d="M16.0729 9.56494C14.999 9.56494 14.1253 10.4386 14.1253 11.5125C14.1253 11.843 14.2083 12.1544 14.3542 12.4273C14.5621 12.8163 14.898 13.1268 15.3054 13.3021C15.5411 13.4036 15.8005 13.46 16.0729 13.46C17.1467 13.46 18.0204 12.5864 18.0204 11.5125C18.0204 10.4386 17.1467 9.56494 16.0729 9.56494Z"
              fill="white"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="15.0001"
          height="15.0001"
          fill="white"
          transform="translate(4.00006 5.99976)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'SvgAuditorium',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>

<style>

</style>
